import React from "react";
import { Modal, Form, Input, Switch } from "antd";

const ConnectorModal = ({ visible, onCancel, onSave }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSave(values);
        form.resetFields();
      })
      .catch(() => {});
  };

  return (
    <Modal
      title="Create New Connector"
      open={visible}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText="Save"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="systemName"
          label="System Name"
          rules={[{ required: true, message: "System Name is required" }]}
        >
          <Input placeholder="Enter system name" />
        </Form.Item>

        <Form.Item
          name="name"
          label="Connector Name"
          rules={[{ required: true, message: "Connector Name is required" }]}
        >
          <Input placeholder="Enter connector name" />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} placeholder="Enter description" />
        </Form.Item>

        <Form.Item
          name="active"
          label="Active"
          valuePropName="checked"
          initialValue={true}
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConnectorModal;
